// Category metadata used across the app
export const CATEGORIES = [
  { key: "announcements", label: "Announcements", icon: "📢", color: "bg-[#B31B1B] text-white", chip: "bg-[#B31B1B]/10 text-[#B31B1B]" },
  { key: "internships",   label: "Internships",   icon: "🎓", color: "bg-amber-100 text-amber-900",  chip: "bg-amber-50 text-amber-800" },
  { key: "employment",    label: "Employment",    icon: "💼", color: "bg-emerald-100 text-emerald-900", chip: "bg-emerald-50 text-emerald-800" },
  { key: "industry",      label: "Industry Insights", icon: "🏭", color: "bg-sky-100 text-sky-900",  chip: "bg-sky-50 text-sky-800" },
  { key: "introductions", label: "Introductions", icon: "🤝", color: "bg-violet-100 text-violet-900", chip: "bg-violet-50 text-violet-800" },
  { key: "general",       label: "General",       icon: "💬", color: "bg-neutral-100 text-neutral-800", chip: "bg-neutral-100 text-neutral-700" },
];

export const CATEGORY_MAP = Object.fromEntries(CATEGORIES.map((c) => [c.key, c]));

export function getCategory(key) {
  return CATEGORY_MAP[key] || CATEGORIES[CATEGORIES.length - 1];
}
